import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  DISCOUNT_CODE_AUTHORIZER_PATH,
  DISCOUNT_CODE_PATH,
} from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import DiscountAuthorizerForm from './DiscountCodeAuthorizerForm';
import {
  clearDiscountCodeAuthorizer,
  getDiscountCodeAuthorizer,
  putDiscountCodeAuthorizer,
} from '../../../../actions/sales/DiscountCodeAuthorizer';

const EditDiscountAuthorizer = ({
  breadcrumbs,
  dispatchGetDiscountCodeAuthorizer,
  dispatchClearDiscountCodeAuthorizer,
  dispatchPutDiscountCodeAuthorizer,
  match: {
    params: { id: discountCodeAuthorizerId },
  },
  loading,
  discountCodeAuthorizer,
}) => {
  useLayoutEffect(() => {
    dispatchGetDiscountCodeAuthorizer({ discountCodeAuthorizerId });

    return () => dispatchClearDiscountCodeAuthorizer();
  }, []);

  const onSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      customerId: formValues.customerId.value,
    };
    dispatchPutDiscountCodeAuthorizer(discountCodeAuthorizerId, newFormValues);
  };

  const generateInitialValues = (discountCodeAuthorizerJson) => ({
    active: discountCodeAuthorizerJson.active,

    customerId: discountCodeAuthorizerJson.customer
      ? {
          value: discountCodeAuthorizerJson.customer.id,
          label: discountCodeAuthorizerJson.customer.fullName,
        }
      : null,
  });

  let content;

  if (loading) content = <Loader />;
  else if (discountCodeAuthorizer.isEmpty())
    content = <NoDataResource returnPage={DISCOUNT_CODE_PATH} />;
  else
    content = (
      <DiscountAuthorizerForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(discountCodeAuthorizer.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Código de Descuento"
      subtitle="Editar código de descuento"
      content={content}
    />
  );
};

EditDiscountAuthorizer.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearDiscountCodeAuthorizer: PropTypes.func.isRequired,
  dispatchGetDiscountCodeAuthorizer: PropTypes.func.isRequired,
  dispatchPutDiscountCodeAuthorizer: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  discountCodeAuthorizer: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditDiscountAuthorizer.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearDiscountCodeAuthorizer: clearDiscountCodeAuthorizer,
  dispatchGetDiscountCodeAuthorizer: getDiscountCodeAuthorizer,
  dispatchPutDiscountCodeAuthorizer: putDiscountCodeAuthorizer,
};

const mapStateToProps = (
  { SalesUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Autorizadores de Códigos de Descuento',
      href: DISCOUNT_CODE_AUTHORIZER_PATH,
    },
    {
      text: 'Ver',
      href: `${DISCOUNT_CODE_AUTHORIZER_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  discountCodeAuthorizer: SalesUnit.DiscountCodeAuthorizer.getIn([
    'current',
    'content',
  ]),
  loading: !SalesUnit.DiscountCodeAuthorizer.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditDiscountAuthorizer);
